import { NavLink } from "react-router-dom";
import { useAppSelector } from "../../../redux/store";
import { getRoutePath } from "../../routes/routes";

function ConfirmationFinal({ point, onHide, phone, compte }) {
  const user = useAppSelector((s) => s.user.user);
  // Le backend a trouve un compte pour l'email de la contribution et y a
  // deja credite les points : inutile de proposer une inscription.
  const aDejaUnCompte = compte === "1";
  return (
    <>
      <div className="modal-investissement-description-content2">
        <div className="modal-investissement-description-confirm">
          Confirmation
        </div>
        <div className="modal-investissement-confirm-para-container">
          <div className="modal-investissement-confirm-para">
            Votre contribution est bien prise en compte. Vous venez de recevoir{" "}
            <span className="modal-investissement-confirm-para-span">
              {point} points.
            </span>
          </div>
          {!user?.id &&
            (aDejaUnCompte ? (
              <div className="modal-investissement-confirm-para">
                Ces points ont été ajoutés à votre compte.{" "}
                <NavLink
                  to={getRoutePath("login")}
                  onClick={onHide}
                  className="modal-investissement-confirm-para-span"
                >
                  Connectez-vous pour les consulter
                </NavLink>
              </div>
            ) : (
              <div className="modal-investissement-confirm-para">
                <NavLink
                  to={getRoutePath("register")}
                  onClick={onHide}
                  state={{ phone }}
                  className="modal-investissement-confirm-para-span"
                >
                  je m'inscris pour récupérer mes points
                </NavLink>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default ConfirmationFinal;
